import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0" }
const _hoisted_2 = { class: "p-col-12 " }
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = { class: "p-float-label kn-flex p-mr-2" }
const _hoisted_5 = {
  class: "kn-material-input-label",
  for: "label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  class: "kn-material-input-label",
  for: "label"
}
const _hoisted_8 = { class: "schedulerContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_KnScheduler = _resolveComponent("KnScheduler")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary dataPreparationSaveDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('managers.workspaceManagement.dataPreparation.savePreparedDataset'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button--secondary",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.cancel
      }, null, 8, ["label", "onClick"]),
      _withDirectives(_createVNode(_component_Button, {
        class: "kn-button--primary",
        disabled: _ctx.saveButtonDisabled,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.savePreparedDataset()))
      }, null, 8, ["disabled"]), [
        [_directive_t, 'common.save']
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.preparedDataset.name.$invalid
                            }],
                type: "text",
                disabled: !_ctx.isFirstSave,
                modelValue: _ctx.v$.preparedDataset.name.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.preparedDataset.name.$model = $event)),
                modelModifiers: { trim: true },
                maxLength: "100",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.touched = true))
              }, null, 8, ["disabled", "modelValue", "class"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.dataset.name')), 1),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.preparedDataset.name,
                additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.configurationManagement.headers.name')
                            }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ])
          ]),
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Textarea, {
              class: ["kn-material-input p-mb-1", {
                            'p-invalid': _ctx.v$.preparedDataset.description.$invalid
                        }],
              type: "text",
              disabled: !_ctx.isFirstSave,
              modelValue: _ctx.v$.preparedDataset.description.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.preparedDataset.description.$model = $event)),
              modelModifiers: { trim: true },
              rows: "3",
              maxLength: "10000",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.touched = true))
            }, null, 8, ["disabled", "modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.dataset.description')), 1),
            _createVNode(_component_KnValidationMessages, {
              vComp: _ctx.v$.preparedDataset.description,
              additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.configurationManagement.headers.description')
                        }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_KnScheduler, {
            class: "p-m-1",
            cronExpression: _ctx.currentCronExpression,
            cronExpressionType: _ctx.cronExpressionType,
            descriptor: _ctx.schedulerDescriptor,
            onTouched: _cache[5] || (_cache[5] = ($event: any) => (_ctx.touched = true)),
            logsVisible: false,
            schedulationEnabled: _ctx.schedulationEnabled,
            schedulationPaused: _ctx.schedulationPaused,
            "onUpdate:schedulationPaused": _ctx.updateSchedulationPaused,
            "onUpdate:schedulationEnabled": _ctx.updateSchedulationEnabled,
            "onUpdate:currentCronExpression": _ctx.updateCurrentCronExpression,
            "onUpdate:cronExpressionType": _ctx.updateCronExpressionType
          }, null, 8, ["cronExpression", "cronExpressionType", "descriptor", "schedulationEnabled", "schedulationPaused", "onUpdate:schedulationPaused", "onUpdate:schedulationEnabled", "onUpdate:currentCronExpression", "onUpdate:cronExpressionType"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}